import { normalizeSearchQuery } from "@/lib/normalize-search-query";
import { orpc } from "@/utils/orpc.client";

interface ArtistSearchQueryOptionsInput {
  query: string;
  genre?: string;
  style?: string;
  artistCountry?: string;
  enabled?: boolean;
}

export function getArtistSearchQueryOptions(input: ArtistSearchQueryOptionsInput) {
  const query = normalizeSearchQuery(input.query);
  return orpc.music.searchArtists.queryOptions({
    input: {
      query,
      genre: input.genre,
      style: input.style,
      artistCountry: input.artistCountry,
    },
    enabled: input.enabled,
  });
}
